/* eslint-disable */
import { ElementRef } from "@angular/core";

export class StyleUtils {
    static setScssProperty(elRef: ElementRef | HTMLElement, propertyName: string, propertyValue: string) {
        if (elRef instanceof HTMLElement) {
            elRef.style.setProperty(propertyName, propertyValue);
        } else {
            elRef.nativeElement.style.setProperty(propertyName, propertyValue);
        }
    }
}
